module.exports = __webpack_public_path__ + "img/send.0391889f.svg";